<app-create-pricing-group [visible]="createDrawerVisible" (visibleChange)="createDrawerVisible = $event; createDrawerVisibleChange.emit($event)" (saved)="loadPricingGroupData()" />
<app-update-pricing-group [visible]="updateDrawerVisible" (visibleChange)="updateDrawerVisible = $event; updateDrawerVisibleChange.emit($event)" [id]="pricingGroupIdEditing" />

<div class="card border-0">
  <div class="card-body">
    <p-table [value]="listPricingGroup" dataKey="id" editMode="row" showGridlines [tableStyle]="{ 'min-width': '60rem' }">
      <ng-template #header>
        <tr>
          <th style="width: 50px">ID</th>
          <th>Grupo</th>
          <th colspan="2">Fecha de registro</th>
        </tr>
      </ng-template>
      <ng-template #body let-item let-editing="editing" let-ri="rowIndex">
        <tr [pEditableRow]="item">
          <td>{{ item.userPricingGroupId }}</td>
          <td>{{ item.label }}</td>
          <td style="width: 200px">{{ item.dateCreated | date : "longDate" }}</td>
          <td style="width: 10px">
            <div class="d-flex gap-2">
              <p-button icon="pi pi-pencil" class="p-button-text" (click)="updatePricingGroup(item.userPricingGroupId)" />
              <p-button icon="pi pi-trash" severity="danger" class="p-button-text" (click)="delete($event, item.userPricingGroupId)" />
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
